module.exports = __webpack_public_path__ + "img/logo.e9c1dee3.png";